import styled, { css } from "styled-components";

export const FloatingLabelInputWrapper = styled.div`
	position: relative;
	border-radius: 50px;
	background: var(--input-bg-has-value);
	display: flex;
	height: 40px;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;

	&.focused label,
	&.filled label {
		top: 10px;
		opacity: 1;
		color: #a0a3bd;
		font-size: 10px;
		font-weight: 400;
		line-height: 12px;
		letter-spacing: 0.25px;
		z-index: 999;
	}

	label {
		position: absolute;
		top: 0;
		left: 0;
		transition: all 0.3s ease;
		opacity: 0.5;
		z-index: 2;
		color: #a0a3bd;
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.3px;
		top: 50%;
		left: 20px;
		transform: translateY(-50%);
	}

	.ant-input {
		color: var(--content-text-color) !important;
		font-size: 12px !important;
		font-weight: 400 !important;
		line-height: 16px !important;
		letter-spacing: 0.3px !important;
		width: 100%;
		height: 100%;
		background: var(--input-bg-has-value) !important;
		border-radius: 50px;
		border: none !important;
		padding: 10px 20px 0px 5px !important;
		height: 40px !important;
		margin-left: 15px;
	}

	.ant-input[disabled] {
		border-color: var(--main-explosive) !important;
	}

	input:-webkit-autofill,
	input:-webkit-autofill:hover,
	input:-webkit-autofill:focus,
	input:-webkit-autofill:active,
	.ant-input-affix-wrapper > input.ant-input:focus {
		-webkit-box-shadow: 0 0 0 30px var(--input-bg-has-value) inset !important;
		border-top-right-radius: 0 !important;
		border-bottom-right-radius: 0 !important;
		-webkit-text-fill-color: #fff !important;
		width: 100% !important;
	}

	.ant-input:focus {
		box-shadow: none !important;
	}

	.ant-input-affix-wrapper {
		padding: 0 !important;
		box-shadow: none !important;
		border: 1px solid var(--main-explosive);
		background: var(--input-bg-has-value) !important;
	}

	${({ isEmpty }) =>
		isEmpty &&
		css`
			.ant-input-affix-wrapper,
			.ant-input {
				background: #262338 !important;
				border: none !important;
			}
		`}

	${({ hasLessBorderRadius }) =>
		hasLessBorderRadius &&
		css`
			.ant-input {
				background: var(--input-bg-has-value) !important;
			}

			.ant-input-affix-wrapper {
				border-radius: 10px !important;
				border: 1px solid var(--main-explosive) !important;
				background: var(--input-bg-has-value) !important;
			}
		`}
`;
